import { textFunctions } from "../../../../../../themes/custom/ev_theme/frontend/js/common/constants/functions/textFunctions";
import { createStaticSlider, initWhenReady } from "../../../../../../themes/custom/ev_theme/frontend/js/components/sliders";
import { dataCalculator } from "../../../../../../themes/custom/ev_theme/frontend/js/modules/form/setValueForm";
import { fieldsBuilder, loadApisBuilder } from "../../builder-filter";
import { loadApis } from "../results-load/load";
import { data_list, data_select, list_filters } from "../results-load/results-state";
import { filterString } from "../results-load/results-query";
import { loadMap } from "../map";
import { closeAllSimulationData, loadAds, loadSliderHiglighted } from "../script";
import { clearData, updateFiltersRange } from "./sliderRange";
import { orderYearsList } from "../results-load/results-ui";
import { loadBannerBuilder } from "../results-load/builder-load";
import { fecha_list, feature_list, setFechaList, name_list_filters } from "../results-load/results-state";
import { formState } from "../../../../../../themes/custom/ev_theme/frontend/js/modules/form/FormState";
import { loadDataAVI } from "../../../../../../themes/custom/ev_theme/frontend/js/common/constants/functions/loadDataAVI";
window.toggleCategories = toggleCategories;
window.toggleGeneral = toggleGeneral;
window.showFilters = showFilters;
const valueField = {
    'tipo_list': 'type',
    'city_list': 'cities',
    'zone_list': 'zone',
    'sector_list': 'sector',
    'department_list': 'department_list',
    'constructor_highlight': 'constructor_highlight'
};
export let fields = {};
function initializeFields() {
    fields = {
        'constructor_highlight': document.getElementById('constructor_highlight_value'),
        'department_list': document.getElementById('department_value'),
        'cities': document.getElementById('cities_value'),
        'zone': document.getElementById('zone_value'),
        'sector': document.getElementById('sector_value'),
    };
}
document.addEventListener('DOMContentLoaded', () => {
    initializeFields();
});
const data_index = {
    'alcobas': 0,
    'banio': 0,
    'garage': 0,
    'estrato': 0,
};
export function addselect(data, field, isBuilder) {
    var _a, _b, _c;
    if (data_select[field].includes(data)) {
        data_select[field] = data_select[field].filter(item => item !== data);
    }
    else if (['vis', 'fecha', 'type'].includes(field)) {
        data_select[field] = [data];
    }
    else {
        data_select[field].push(data);
    }
    const fieldsData = isBuilder ? fieldsBuilder : fields;
    if (fieldsData[field]) {
        if (data_select[field].length, 'lenght') {
            const elementKey = Object.keys(data_list).find(k => valueField[k] === field || k === field);
            const lastTid = data_select[field][data_select[field].length - 1];
            const lastItem = (_a = data_list[elementKey]) === null || _a === void 0 ? void 0 : _a.find(el => el.tid == lastTid);
            fieldsData[field].value = (lastItem === null || lastItem === void 0 ? void 0 : lastItem.label) || '';
        }
        else {
            fieldsData[field].value = '';
        }
    }
    if (field === 'cities') {
        const cities = data_select['cities'] || [];
        const shouldShow = cities.length == 1 &&
            Number(cities[0]) == 20624;
        (_b = document.getElementById('zone-wrapper')) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none', !shouldShow);
        (_c = document.getElementById('neighborhood-wrapper')) === null || _c === void 0 ? void 0 : _c.classList.toggle('d-none', !shouldShow);
    }
    loadChangeFilters(data, field, isBuilder);
}
function getlabelCiudad(id) {
    let zona_select = data_list.zone_list.find(x => x.tid === id);
    let ciudad_select = zona_select ? data_list.city_list.find(x => { var _a; return x.tid == ((_a = zona_select.parent) === null || _a === void 0 ? void 0 : _a.toString()); }) : null;
    return (ciudad_select === null || ciudad_select === void 0 ? void 0 : ciudad_select.label) || '';
}
function getlabelCiudad_zona(id) {
    let sector_select = data_list.sector_list.find(x => x.tid === id);
    let zona_select = sector_select ? data_list.zone_list.find(x => { var _a; return x.tid === ((_a = sector_select.parent) === null || _a === void 0 ? void 0 : _a.toString()); }) : null;
    let ciudad_select = zona_select ? data_list.city_list.find(x => { var _a; return x.tid === ((_a = zona_select.parent) === null || _a === void 0 ? void 0 : _a.toString()); }) : null;
    return ciudad_select ? `${ciudad_select.label} - ${zona_select === null || zona_select === void 0 ? void 0 : zona_select.label}` : '';
}
function isOtherFilterKey(value) {
    return value in name_list_filters;
}
export function updateOtherFilterUI(item) {
    var _a, _b, _c, _d;
    if (!isOtherFilterKey(item))
        return;
    const filterValue = (_a = data_select[item]) === null || _a === void 0 ? void 0 : _a[0];
    const filter = document.getElementById('value-filter-' + item);
    const minusBtn = document.getElementById('minus-' + item);
    const plusBtn = document.getElementById('plus-' + item);
    const currentIndex = (_b = data_index[item]) !== null && _b !== void 0 ? _b : 0;
    const key = name_list_filters[item];
    const maxLength = (_d = (_c = list_filters[key]) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    if (!filter || !minusBtn || !plusBtn)
        return;
    filter.textContent = filterValue !== null && filterValue !== void 0 ? filterValue : '0';
    filter.classList.toggle('inactive', filterValue == null);
    minusBtn.disabled = currentIndex <= 0;
    plusBtn.disabled = currentIndex >= maxLength - 1;
}
export function nextOtherFilter(item, list) {
    var _a, _b, _c;
    const filters = list_filters[list];
    if (!(filters === null || filters === void 0 ? void 0 : filters.length))
        return;
    const idx = (_a = data_index[item]) !== null && _a !== void 0 ? _a : 0;
    data_select[item][0] = (_c = (_b = filters[idx]) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : filters[idx];
    data_index[item] = idx + 1;
    updateOtherFilterUI(item);
    loadChangeFilters(String(data_select[item][0]), item, false);
}
function hideOtherFilter(item) {
    var _a;
    let filters = {
        'alcobas': ['banio', 'garage', 'estrato'],
        'banio': ['garage', 'estrato'],
        'garage': ['estrato'],
    };
    (_a = (filters[item])) === null || _a === void 0 ? void 0 : _a.forEach(element => {
        data_select[element].pop();
        data_index[element] = 0;
    });
}
export function backOtherFilter(item, list) {
    var _a, _b;
    const currentIndex = (_a = data_index[item]) !== null && _a !== void 0 ? _a : 0;
    const currentValues = data_select[item];
    if (!Array.isArray(currentValues))
        return;
    const filters = list_filters[list];
    if (!Array.isArray(filters) || filters.length === 0)
        return;
    if (currentIndex <= 1) {
        data_index[item] = 0;
        currentValues.pop();
        hideOtherFilter(item);
    }
    else if (currentValues.length > 0) {
        const value = currentValues[0];
        const foundIndex = filters.findIndex((filterItem) => filterItem.filter == value);
        const previousIndex = foundIndex - 1;
        if (previousIndex < 0 || !filters[previousIndex])
            return;
        currentValues[0] = filters[previousIndex].filter;
        data_index[item] = previousIndex;
    }
    updateOtherFilterUI(item);
    loadChangeFilters((_b = data_select[item]) === null || _b === void 0 ? void 0 : _b[0], item, false);
}
function loadBreadcrumb(path) {
    const breadcrumb = document.querySelector('.breadcrumb');
    const optionsBreadcrumb = {
        'proyectos-vivienda': 'Proyectos de vivienda',
        'apartamentos': 'Apartamentos',
        'apartaestudios': 'Apartaestudios',
        'outlet-inmobiliario': 'Outlet Inmobiliario Estrenar Vivienda',
        'vivienda-interes-social': 'Vivienda de Interés Social',
    };
    let breadcrumbHTML = '<li class="breadcrumb-item"><a href="/">Inicio</a></li>';
    let pathBreadcrumb = window.location.origin;
    path.forEach((segment, index) => {
        if (segment) {
            let nameBreadcrumb = optionsBreadcrumb[segment] ? segment.replace(segment, optionsBreadcrumb[segment]) : segment.charAt(0).toUpperCase() + segment.slice(1).replace('-', ' ');
            nameBreadcrumb = index == 1 ? nameBreadcrumb.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : nameBreadcrumb;
            pathBreadcrumb += `/${segment}`;
            breadcrumbHTML += `<li class="breadcrumb-item"><a href="${pathBreadcrumb}">${nameBreadcrumb}</a></li>`;
        }
    });
    breadcrumb.innerHTML = breadcrumbHTML;
}
export function loadUrlPath(data, field, filter, isBuilder) {
    let params = new URLSearchParams(filter);
    let currentPath = window.location.pathname.split('/');
    // VALIDATION FOR /feria-propia/
    if (currentPath[1] == 'feria-propia') {
        currentPath[1] = currentPath[1] + '/' + currentPath[2];
        currentPath.splice(2, 1);
    }
    let path = '';
    let section_type_param = params.get("section_type") || '';
    if (currentPath[1] === 'proyectos-vivienda' || (filter.includes('?section_type=property_type') && !filter.includes('&type=')) || document.getElementById('js-unpublished-project')) {
        path = '/proyectos-vivienda';
    }
    else if (['builder', 'project', 'type_vis', 'delivery', 'type_category', 'project_collection', 'outlet', 'white_brand'].includes(section_type_param)) {
        path = '/' + currentPath[1];
    }
    const getPathForField = () => {
        if (params.get('sector'))
            return getPath(data, params, path, 'sector');
        if (params.get('zone'))
            return getPath(data, params, path, 'zone');
        if (params.get('cities'))
            return getPath(data, params, path, 'cities');
        if (params.get('type')) {
            const type_data = filterPath(params.get('type') || '', data_list.tipo_list);
            return path + '/' + stringTransformation(type_data.label) + 's';
        }
        return path;
    };
    switch (field) {
        case 'type':
            path = getPathForField();
            break;
        case 'department':
            break;
        case 'cities':
        case 'zone':
        case 'sector':
            path = getPath(data, params, path, field);
            break;
        default:
            path = getPathForField();
            break;
    }
    if (!isBuilder) {
        const currentParams = window.location.search;
        window.history.pushState({ field_type: field }, 'null', `${path}${currentParams}`);
    }
    return path || '';
}
function getPath(data, params, basicPath, key) {
    let path = basicPath;
    function getLabel(value, list) {
        const item = filterPath(value || '', list);
        return stringTransformation((item === null || item === void 0 ? void 0 : item.label) || '');
    }
    if (params.get('type')) {
        const type_data = filterPath(params.get('type') || '', data_list.tipo_list);
        path += '/' + stringTransformation(type_data.label) + 's';
    }
    switch (key) {
        case 'cities':
            if (params.get(key)) {
                path += '/' + getLabel(params.get(key) || '', data_list.city_list);
            }
            break;
        case 'zone':
            if (params.get(key)) {
                const zone_data = filterPath(params.get(key) || '', data_list.zone_list);
                const city = getLabel(zone_data.parent, data_list.city_list);
                const zone = stringTransformation(zone_data.label);
                path += '/' + city + '/' + zone;
            }
            else {
                const zone_data = filterPath(data, data_list.zone_list);
                const city = getLabel(zone_data.parent, data_list.city_list);
                const cityParam = params.get('cities');
                if (cityParam && city) {
                    path += `/${city}`;
                }
            }
            break;
        case 'sector':
            if (params.get(key)) {
                const sector_data = filterPath(params.get(key) || '', data_list.sector_list);
                const zone_data = filterPath(sector_data.parent, data_list.zone_list);
                const city = getLabel(zone_data.parent, data_list.city_list);
                const zone = stringTransformation(zone_data.label);
                const sector = stringTransformation(sector_data.label);
                path += '/' + city + '/' + zone + '/' + sector;
            }
            else {
                const sector_data = filterPath(data, data_list.sector_list);
                const zone_data = filterPath(sector_data.parent, data_list.zone_list);
                const city = getLabel(zone_data.parent, data_list.city_list);
                const zone = stringTransformation(zone_data.label);
                const cityParam = params.get('cities');
                const zoneParam = params.get('zone');
                if (cityParam && city) {
                    path += `/${city}`;
                }
                if (zoneParam && zone) {
                    path += `/${zone}`;
                }
            }
            break;
    }
    return path;
}
function filterPath(value, facets) {
    return Object.values(facets).find(e => e.tid == value.split(',').pop());
}
function stringTransformation(path) {
    return path
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[\s\/]+/g, '-')
        .replace(/[,\.\+&\*()]/g, '')
        .replace(/-{2,}/g, '-');
}
function getList(finalRes) {
    const facetas = finalRes.facetas;
    const dataMap = {
        'type': 'property_type',
        'cities': 'project_city',
        'department_list': 'field_location_department',
        'constructor_highlight': 'field_builder_id',
        'sector': 'project_neighborhood',
        'zone': 'project_zone',
        'fecha': 'fecha_de_entrega_anio'
    };
    Object.keys(valueField).forEach(key => {
        var _a, _b;
        const field = valueField[key];
        if (data_select[field] && data_select[field].length <= 0) {
            data_list[key] = field === 'department_list'
                ? ((_a = facetas[dataMap[field]]) !== null && _a !== void 0 ? _a : []).filter((x) => x.parent == 0)
                : ((_b = facetas[dataMap[field]]) !== null && _b !== void 0 ? _b : []);
        }
    });
    if (data_select['fecha'].length <= 0) {
        setFechaList(orderYearsList(facetas.fecha_de_entrega_anio));
    }
}
function updateVisCheckboxes(params, isBuilder) {
    const valueVis = params.get("vis") || '';
    const nameField = (value) => {
        return isBuilder ? value + '-builder' : value;
    };
    const todos = document.getElementById(nameField('todos'));
    const vis = document.getElementById(nameField('vis'));
    const novis = document.getElementById(nameField('novis'));
    if (todos && vis && novis) {
        if (valueVis === '20220,20260,20223,7897') {
            todos.checked = false;
            vis.checked = false;
            novis.checked = true;
        }
        else if (['20220,20260,20223,7897,11660,12211,11801', '11660,12211,11801,20220,20260,20223,7897'].includes(valueVis)) {
            todos.checked = true;
            vis.checked = false;
            novis.checked = false;
        }
        else if (valueVis === '11660,12211,11801' || valueVis === '11660,11801') {
            todos.checked = false;
            vis.checked = true;
            novis.checked = false;
        }
        else {
            todos.checked = true;
            vis.checked = false;
            novis.checked = false;
        }
    }
}
export async function loadChangeFilters(data, field, isBuilder) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const fieldsData = isBuilder ? fieldsBuilder : fields;
    const range = isBuilder ? window.rangeValueBuilder : window.rangeValue;
    const filterVis = isBuilder ? 'vis-builder' : 'vis';
    let filter = filterString();
    // Send double order data if delivery is selected
    if (filter.includes("delivery")) {
        filter = filter.replace("delivery,ASC", "delivery,ASC,precio,ASC");
    }
    let params = new URLSearchParams(filter);
    if (field == filterVis && data == '20220,20260,20223,7897,11660,12211,11801' && params.get(filterVis)) {
        let uniqueVis = [...new Set((_a = params.get(filterVis)) === null || _a === void 0 ? void 0 : _a.split(','))].join(',');
        params.set(filterVis, uniqueVis);
    }
    else {
        const inputcheck = isBuilder ? 'todos-builder' : 'todos';
        const inputElement = document.getElementById(inputcheck);
        if (inputElement) {
            inputElement.checked = false;
        }
    }
    loadBannerBuilder();
    // Update UI elements based on filters
    updateVisCheckboxes(params, isBuilder);
    // Update path and breadcrumbs
    let path = loadUrlPath(data, field, filter, isBuilder);
    if (window.location.pathname != '/que-estas-buscando') {
        loadBreadcrumb(path.split('/'));
    }
    filter += `&url=${path}`;
    if (!filter) {
        filter = `?range=${range}`;
    }
    else {
        filter += `&range=${range}`;
    }
    if (filter.includes('project') && field === 'department_list' && !filter.includes('project_collection')) {
        filter = `?section_type=property_type&url=/proyectos-vivienda`;
        data_select['section_type'] = ['property_type'];
        data_select['section_type_value'] = [];
        (_b = document.getElementById('cities_value')) === null || _b === void 0 ? void 0 : _b.removeAttribute('disabled');
        (_c = document.getElementById('results-banner-project')) === null || _c === void 0 ? void 0 : _c.remove();
        (_d = document.getElementById('more-results')) === null || _d === void 0 ? void 0 : _d.classList.remove("d-none");
        clearFilter();
    }
    let finalRes = isBuilder ? await loadApisBuilder(filter) : await loadApis(filter);
    if (field == 'cities') {
        if (((_e = fieldsData['cities']) === null || _e === void 0 ? void 0 : _e.value) === '') {
            (_f = fieldsData['zone']) === null || _f === void 0 ? void 0 : _f.setAttribute('disabled', 'true');
            const inputElement = fieldsData['department_list'];
            if (data_select.department_list.length === 0 && inputElement) {
                inputElement.value = '';
            }
        }
        else {
            (_g = fieldsData['zone']) === null || _g === void 0 ? void 0 : _g.removeAttribute('disabled');
        }
    }
    if (((_h = fieldsData['zone']) === null || _h === void 0 ? void 0 : _h.value) === '') {
        (_j = fieldsData['sector']) === null || _j === void 0 ? void 0 : _j.setAttribute('disabled', 'true');
    }
    else {
        (_k = fieldsData['sector']) === null || _k === void 0 ? void 0 : _k.removeAttribute('disabled');
    }
    if (!finalRes.facetas.field_builder_id.length) {
        (_l = fieldsData['constructor_highlight_value']) === null || _l === void 0 ? void 0 : _l.setAttribute('disabled', 'true');
    }
    else {
        (_m = fieldsData['constructor_highlight_value']) === null || _m === void 0 ? void 0 : _m.removeAttribute('disabled');
    }
    if (finalRes.NumItems <= 12) {
        (_o = document.getElementById('more-results')) === null || _o === void 0 ? void 0 : _o.classList.add('d-none');
    }
    else {
        (_p = document.getElementById('more-results')) === null || _p === void 0 ? void 0 : _p.classList.remove('d-none');
    }
    if (!isBuilder) {
        loadSliderHiglighted('featuredProjectsVue');
        loadAds();
        window.app.datos1.forEach((element) => {
            initWhenReady(() => {
                const cardImages = document.getElementById('splide' + element.field_node_id);
                if (!cardImages)
                    return;
                createStaticSlider(cardImages, {
                    perPage: 1,
                    classes: { arrow: 'splide__arrow splide__arrow--blue' },
                }, { lazy: true });
            });
            const downPaymentPercentage = 30;
            const yearsTerm = 20;
            element.field_montly_quote =
                dataCalculator.calculateQuote(element.field_typology_price, element.field_tipo_de_vivienda, downPaymentPercentage, yearsTerm);
        });
    }
    loadMap(filter);
    updateFiltersRange(finalRes);
    // get filter options
    getList(finalRes);
    // send the data to vue
    renderFilters(isBuilder);
    closeAllSimulationData();
}
function resetLocationFilters() {
    const locationInputsFilters = document.querySelectorAll('.checkbox-filter-list input:checked');
    locationInputsFilters.forEach((input) => {
        input.checked = false;
    });
}
function resetOrderFilters() {
    const orderByFilter = document.querySelectorAll('.js-results-content-filters .order-filter--selected');
    orderByFilter.forEach((item) => {
        item.classList.remove('order-filter--selected');
    });
}
function resetLoadOrderInput() {
    const loadOrderInput = document.getElementById("loadOrderInput");
    if (loadOrderInput) {
        loadOrderInput.setAttribute("placeholder", 'Ordenar por');
    }
}
function resetCheckboxes() {
    document.querySelectorAll('.filters input:checked').forEach((checkbox) => {
        checkbox.checked = false;
    });
}
function resetDataSelection() {
    Object.keys(fields).forEach(element => {
        fields[element].value = '';
        data_select[element] = [];
    });
    data_select['fecha'] = [];
    data_select['type'] = [];
}
export async function clearFilter() {
    var _a, _b, _c, _d, _e;
    // Clear styles and reset filters
    resetCheckboxes();
    resetLocationFilters();
    resetOrderFilters();
    resetLoadOrderInput();
    // clean area and price values
    clearData();
    let urlParams = new URLSearchParams(filterString());
    let sectionType = urlParams.get("section_type");
    let filter = `?section_type=${sectionType}`;
    if (sectionType !== "property_type") {
        filter += `&section_type_value=${urlParams.get("section_type_value")}`;
    }
    // Clear filters and projects
    let filtersDataSelect = filterString();
    if (filtersDataSelect.includes('project')) {
        filter = `?section_type=property_type&url=/proyectos-vivienda`;
        data_select['section_type'] = ['property_type'];
        data_select['section_type_value'] = [];
        (_a = document.getElementById('cities_value')) === null || _a === void 0 ? void 0 : _a.removeAttribute('disabled');
        (_b = document.getElementById('results-banner-project')) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = document.getElementById('more-results')) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
    }
    const path = loadUrlPath('', '', filter, false);
    loadBreadcrumb(path.split('/'));
    filter += `&url=${path}`;
    let finalRes = await loadApis(filter);
    if (!finalRes.facetas.field_builder_id.length) {
        (_d = fields['constructor_highlight_value']) === null || _d === void 0 ? void 0 : _d.setAttribute('disabled', 'true');
    }
    else {
        (_e = fields['constructor_highlight_value']) === null || _e === void 0 ? void 0 : _e.removeAttribute('disabled');
    }
    loadMap(filter);
    //filter
    resetDataSelection();
    document.getElementById('first-results-section').innerHTML = '';
    if (document.getElementById('featuredProjectsResults')) {
        document.getElementById('featuredProjectsResults').innerHTML = '';
    }
    initWhenReady(() => {
        window.app.datos1.forEach((element) => {
            const cardImages = document.getElementById('splide' + element.field_node_id);
            if (!cardImages)
                return;
            createStaticSlider(cardImages, {
                perPage: 1,
                classes: { arrow: 'splide__arrow splide__arrow--blue' },
            }, { lazy: true });
            const downPaymentPercentage = 30;
            const yearsTerm = 20;
            element.field_montly_quote = dataCalculator.calculateQuote(element.field_typology_price, element.field_tipo_de_vivienda, downPaymentPercentage, yearsTerm);
        });
        if (window.app.featuredProjects.length > 0) {
            loadSliderHiglighted('featuredProjectsVue');
        }
    });
    Object.keys(data_index).forEach(element => {
        data_select[element].pop();
        data_index[element] = 0;
    });
    data_select['feature'] = [];
    // get filter options
    getList(finalRes);
    // send the data to vue - false for builder
    renderFilters(false);
    closeAllSimulationData();
}
let handleMouseUp;
// close filters if mouse leaves filter box
export function openFilter(value) {
    const isBuilder = value.includes('builder');
    const results = isBuilder ? '.js-builder-content-filters' : '.js-results-content-filters';
    const filterElements = document.querySelectorAll(results);
    const filterId = isBuilder ? 'filters-builder' : 'filters';
    const filterBox = document.getElementById(filterId);
    const activeFilter = document.querySelector(value + ' ' + results);
    if (activeFilter) {
        activeFilter.classList.add("d-block");
        const handleMouseLeave = () => {
            // Check if the active filter is visible and hide it.
            if (activeFilter.classList.contains('d-block')) {
                filterElements.forEach(filter => filter.classList.remove("d-block"));
                filterBox === null || filterBox === void 0 ? void 0 : filterBox.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
        // Add the mouseleave event to hide the filter when the mouse leaves the box
        filterBox === null || filterBox === void 0 ? void 0 : filterBox.addEventListener('mouseleave', handleMouseLeave);
    }
    handleMouseUp = createMouseUpHandler(value, results);
    document.addEventListener('mouseup', handleMouseUp);
}
function createMouseUpHandler(value, results) {
    return function (e) {
        const resultsList = document.querySelector(value);
        if (resultsList && !resultsList.contains(e.target)) {
            const contentResultsBuilderFilter = resultsList.querySelector(results);
            if (contentResultsBuilderFilter) {
                contentResultsBuilderFilter.classList.remove('d-block');
            }
            document.removeEventListener('mouseup', handleMouseUp);
        }
    };
}
document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('.js-search-filter');
    const functions = new textFunctions();
    inputs.forEach((input) => {
        input.addEventListener('keyup', (e) => {
            const patron = functions.formatText(input.value);
            const inputValue = e.target.getAttribute('nameInput');
            if (!inputValue)
                return;
            const listItems = document.querySelectorAll(`.${inputValue} li`);
            let visibleCount = 0;
            listItems.forEach(item => {
                const matches = patron === "" ||
                    functions.formatText(item.textContent || '').indexOf(patron) >= 0;
                item.style.display = matches ? 'flex' : 'none';
                if (matches)
                    visibleCount++;
            });
            const listContainer = document.querySelector(`.${inputValue} .js-builder-content-filters`);
            const hasResults = visibleCount > 0;
            listContainer === null || listContainer === void 0 ? void 0 : listContainer.classList.toggle('d-block', hasResults);
            const noResultsItem = document.querySelector(`.${inputValue}-no-list`);
            noResultsItem === null || noResultsItem === void 0 ? void 0 : noResultsItem.classList.toggle('d-block', visibleCount === 0);
        });
    });
    const currentUrl = window.location.href;
    const urlPerSection = currentUrl.split('/');
    if (urlPerSection[3] === 'vivienda-interes-social') {
        data_select['vis'] = ['11660,11801'];
        let filter = filterString();
        let params = new URLSearchParams(filter);
        updateVisCheckboxes(params, false);
    }
});
export function renderFilters(isBuilder) {
    var _a, _b;
    const contentFilter = isBuilder ? 'js-builder' : 'js-results';
    const fieldsData = isBuilder ? fieldsBuilder : fields;
    const mapToggle = document.getElementById('map-toggle');
    if (mapToggle === null || mapToggle === void 0 ? void 0 : mapToggle.checked) {
        (_a = document.getElementById("datos1")) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
    }
    else {
        (_b = document.getElementById("datos1")) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    Object.keys(data_list).forEach(element => {
        const currentList = data_list[element];
        if (!Array.isArray(currentList)) {
            return;
        }
        let nameList = `.${contentFilter}-${element.replace('_', '-')}`;
        if (element === 'constructor_highlight') {
            nameList = `.${contentFilter}-constructor-highlight-list`;
        }
        const list = document.querySelector(`${nameList} .${contentFilter}-content-filters`);
        const nameListLabel = nameList.replace('list', 'labels');
        const listLabel = document.querySelector(nameListLabel);
        if (list)
            list.innerHTML = '';
        const field = valueField[element] || element;
        if (element === 'tipo_list') {
            const customOrder = ['Apartamento', 'Casa', 'Lote', 'Apartaestudio'];
            currentList.sort((a, b) => {
                return customOrder.indexOf(a.label) - customOrder.indexOf(b.label);
            });
        }
        currentList.forEach((item) => {
            var _a, _b, _c, _d, _e;
            const li = document.createElement('li');
            const input = document.createElement('input');
            input.id = isBuilder ? item.tid + 'builder' : item.tid;
            input.type = 'checkbox';
            input.setAttribute('label', item.label);
            input.setAttribute('onclick', `addselect('${item.tid}', '${field}', ${isBuilder})`);
            if (data_select[field] && data_select[field].includes(item.tid)) {
                input.checked = true;
                if (field == 'cities') {
                    (_b = document.getElementById(((_a = item.parent) === null || _a === void 0 ? void 0 : _a.toString()) || '')) === null || _b === void 0 ? void 0 : _b.setAttribute('checked', 'true');
                    if (fieldsData['department_list']) {
                        if (document.querySelector(`label[for="${item.parent}"]`)) {
                            fieldsData['department_list'].value =
                                ((_c = document.querySelector(`label[for="${item.parent}"]`)) === null || _c === void 0 ? void 0 : _c.innerHTML.split(' (')[0]) || '';
                        }
                    }
                    fieldsData['cities'].value = input.getAttribute('label') || '';
                    (_d = fieldsData['zone']) === null || _d === void 0 ? void 0 : _d.removeAttribute('disabled');
                }
                else if (field == 'zone') {
                    fieldsData['zone'].value = input.getAttribute('label') || '';
                    (_e = fieldsData['sector']) === null || _e === void 0 ? void 0 : _e.removeAttribute('disabled');
                }
                else if (field == 'sector') {
                    fieldsData['sector'].value = input.getAttribute('label') || '';
                }
                else if (field == 'department_list') {
                    fieldsData['department_list'].value = input.getAttribute('label') || '';
                }
                else if (field == 'constructor_highlight_value') {
                    fieldsData['constructor_highlight_value'].value = input.getAttribute('label') || '';
                }
            }
            const label = document.createElement('label');
            const span = document.createElement('span');
            label.setAttribute('for', isBuilder ? item.tid + 'builder' : item.tid);
            if (field != 'constructor_highlight') {
                label.textContent = `${item.label} (${item.count})`;
            }
            else {
                label.textContent = `${item.label}`;
            }
            if (element == 'tipo_list') {
                li.classList.add('filters__options-list-item', 'filters__type');
                const image = document.createElement('img');
                image.src = `/themes/custom/ev_theme/assets/images/results_images/${item.label.toLowerCase()}s.png`;
                image.alt = `Tipo de vivienda: ${item.label}s`;
                image.title = `Tipo de vivienda: ${item.label}s`;
                span.textContent = item.label + 's';
                label.textContent = '';
                input.type = 'radio';
                input.name = 'tipo_list';
                input.classList.add('ev-check-type-filter');
                label.classList.add('ev-check-type-filter__label', 'ev-check-type-filter__label-row');
                image.classList.add('ev-check-type-filter__img');
                image.width = 30;
                image.height = 30;
                label.appendChild(image);
                label.appendChild(span);
            }
            else if (element == 'zone_list' || element == 'sector_list') {
                const div = document.createElement('div');
                const ubication = element == 'zone_list' ? getlabelCiudad(item.tid) : getlabelCiudad_zona(item.tid);
                div.textContent = ubication;
                div.style.fontSize = '0.75em';
                label.insertBefore(div, label.firstChild);
            }
            if (element == 'department_list' ||
                element == 'city_list' ||
                element == 'zone_list' ||
                element == 'sector_list' ||
                element == 'constructor_highlight') {
                li.classList.add('ev-check-list-item');
                input.classList.add('ev-check-input');
                label.classList.add('ev-check-input__label');
            }
            li.appendChild(input);
            li.appendChild(label);
            list === null || list === void 0 ? void 0 : list.appendChild(li);
        });
        if (listLabel)
            listLabel.innerHTML = '';
        const filtersDataSelect = filterString();
        (data_select[field] || []).forEach(tid => {
            const selectedItem = currentList.find(el => el.tid == tid);
            if (!selectedItem)
                return;
            const chip = document.createElement('div');
            chip.classList.add('secondary-invisible-check');
            const text = document.createElement('span');
            text.textContent = selectedItem.label;
            const closeBtn = document.createElement('small');
            closeBtn.classList.add('chip-close');
            chip.addEventListener('click', () => {
                addselect(tid.toString(), field, isBuilder);
            });
            if (field != 'cities' || filtersDataSelect.includes('project_collection') || !filtersDataSelect.includes('project')) {
                chip.appendChild(text);
                chip.appendChild(closeBtn);
                listLabel === null || listLabel === void 0 ? void 0 : listLabel.appendChild(chip);
            }
        });
    });
    if (!isBuilder) {
        const filterFecha = document.querySelector('.js-content-fecha');
        filterFecha ? filterFecha.innerHTML = '' : '';
        fecha_list.forEach((item, index) => {
            const wrapper = document.createElement('div');
            const inputFecha = document.createElement('input');
            inputFecha.type = 'radio';
            inputFecha.name = 'fecha';
            inputFecha.classList.add('invisible-check');
            inputFecha.id = 'fecha_' + item.filter;
            const labelFecha = document.createElement('label');
            labelFecha.htmlFor = inputFecha.id;
            labelFecha.textContent = item.filter;
            inputFecha.checked = data_select['fecha'].includes(item.filter);
            inputFecha.addEventListener('click', () => {
                addselect(item.filter, 'fecha', isBuilder);
            });
            wrapper.appendChild(inputFecha);
            wrapper.appendChild(labelFecha);
            filterFecha === null || filterFecha === void 0 ? void 0 : filterFecha.appendChild(wrapper);
        });
        Object.keys(data_index).forEach((item) => {
            updateOtherFilterUI(item);
        });
        setFeatured();
    }
    let dataAVI = new loadDataAVI(formState);
    dataAVI.setFilters(fields, data_select);
    // Show or hide nextBtn3 in /que-estas-buscando
    const nextBtn3 = document.getElementById('nextBtn3');
    if (nextBtn3) {
        const inputs = document.querySelectorAll('.js-builder-city-list li input');
        inputs.forEach(input => {
            document.addEventListener('change', (ev) => {
                const target = ev.target;
                if (!(target instanceof HTMLInputElement))
                    return;
                if (target.type !== 'checkbox')
                    return;
                const isCity = !!target.closest('.js-builder-city-list');
                const isZone = !!target.closest('.js-builder-zone-list');
                const isSector = !!target.closest('.js-builder-sector-list');
                if (!isCity && !isZone && !isSector)
                    return;
                closeListFromCheckbox(target);
                if (isCity) {
                    const checks = document.querySelectorAll('.js-builder-city-list li input[type="checkbox"]');
                    const hasSelection = Array.from(checks).some(i => i.checked);
                    setLocationErrorUI(hasSelection);
                }
            });
        });
    }
}
function closeListFromCheckbox(checkbox) {
    var _a, _b;
    const container = checkbox.closest('.ev-check-list-container');
    if (!container)
        return;
    (_a = container.querySelector('.js-builder-content-filters')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-block');
    (_b = container.querySelector('.js-results-content-filters')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-block');
}
export function setLocationErrorUI(hasSelection) {
    const wrapper = document.getElementById('wizardCityInput');
    const input = document.querySelector('#wizardCityInput .js-search-filter');
    const nextBtn3 = document.getElementById('nextBtn3');
    const msg = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('p.error');
    if (!wrapper || !input || !nextBtn3)
        return;
    if (hasSelection) {
        wrapper.classList.remove('error', 'is-visible');
        input.classList.remove('error', 'is-visible');
        nextBtn3.style.display = 'block';
        if (msg)
            msg.style.display = 'none';
    }
    else {
        wrapper.classList.add('error', 'is-visible');
        input.classList.add('error', 'is-visible');
        nextBtn3.style.display = 'none';
        if (msg)
            msg.style.display = 'block';
    }
}
function setFeatured() {
    const categories = {};
    const groupedTidsByCategory = {};
    const safeFeatureList = Array.isArray(feature_list) ? feature_list : [];
    const sortedFeatures = [...safeFeatureList]
        .filter(item => item.category)
        .sort((a, b) => b.count - a.count);
    safeFeatureList.forEach((item) => {
        if (item.category) {
            categories[item.category] = categories[item.category] || [];
            groupedTidsByCategory[item.category] = groupedTidsByCategory[item.category] || [];
            categories[item.category].push(item);
            groupedTidsByCategory[item.category].push(item.tid);
        }
    });
    const generalFiltersContainer = document.getElementById('js-general-featured');
    const categoryContainer = document.getElementById('js-specific-featured');
    if (generalFiltersContainer) {
        generalFiltersContainer.innerHTML = '';
    }
    if (categoryContainer) {
        categoryContainer.innerHTML = '';
    }
    Object.entries(categories).forEach(([category, items]) => {
        var _a;
        const wrapper = document.createElement('div');
        const generalInput = document.createElement('input');
        generalInput.type = 'checkbox';
        generalInput.classList.add('invisible-check');
        generalInput.id = `general_${category.replace(/\s+/g, '_')}`;
        const generalLabel = document.createElement('label');
        generalLabel.htmlFor = generalInput.id;
        generalLabel.textContent = category;
        const tids = ((_a = groupedTidsByCategory[category]) === null || _a === void 0 ? void 0 : _a.join(',')) || '';
        const tidsArray = tids ? tids.split(',') : [];
        const allSelected = tidsArray.length > 0 && tidsArray.every(tid => { var _a; return (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid); });
        const someSelected = tidsArray.some(tid => { var _a; return (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid); });
        generalInput.checked = allSelected;
        generalInput.indeterminate = !allSelected && someSelected;
        generalInput.addEventListener('change', () => {
            toggleGeneral(tids, category);
            addselect(tids, 'feature', false);
        });
        wrapper.appendChild(generalInput);
        wrapper.appendChild(generalLabel);
        generalFiltersContainer === null || generalFiltersContainer === void 0 ? void 0 : generalFiltersContainer.appendChild(wrapper);
    });
    sortedFeatures.forEach((item) => {
        var _a;
        const wrapper = document.createElement('div');
        const inputFeature = document.createElement('input');
        inputFeature.type = 'checkbox';
        inputFeature.classList.add('invisible-check');
        inputFeature.id = `feature_${item.tid}`;
        const labelFeature = document.createElement('label');
        labelFeature.htmlFor = inputFeature.id;
        labelFeature.textContent = `${item.label} (${item.count})`;
        const isFeatureActive = (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(item.tid);
        inputFeature.checked = !!isFeatureActive;
        inputFeature.addEventListener('change', () => {
            addselect(item.tid, 'feature', false);
        });
        wrapper.appendChild(inputFeature);
        wrapper.appendChild(labelFeature);
        categoryContainer === null || categoryContainer === void 0 ? void 0 : categoryContainer.appendChild(wrapper);
    });
}
/**
 * Activates or deactivates the general and specific buttons depending on the current selections.
 *
 * This function manages both the activation/deactivation of the general buttons (buttons grouping features) and the activation/deactivation of the specific buttons of each feature.
 * as well as the activation/deactivation of the specific buttons for each feature.
 *
 * @param {string} tids - A text string with the tids separated by comma. Represents a group of related features.
 * @param {string} category - The name of the category to which the features belong.
 */
function toggleGeneral(tids, category) {
    const tidsArray = tids.split(',');
    const allSelected = tidsArray.every(tid => { var _a; return (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid); });
    if (allSelected) {
        data_select['feature'] =
            data_select['feature'].filter((tid) => !tidsArray.includes(tid));
    }
    else {
        data_select['feature'] =
            [...new Set([...data_select['feature'], ...tidsArray])];
    }
    tidsArray.forEach(tid => {
        var _a;
        const featureInput = document.getElementById(`feature_${tid}`);
        if (featureInput) {
            featureInput.checked = (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid);
        }
    });
    const generalInput = document.getElementById(`general_${category.replace(/\s+/g, '_')}`);
    if (generalInput) {
        const nowAllSelected = tidsArray.every(tid => { var _a; return (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid); });
        const nowSomeSelected = tidsArray.some(tid => { var _a; return (_a = data_select['feature']) === null || _a === void 0 ? void 0 : _a.includes(tid); });
        generalInput.checked = nowAllSelected;
        generalInput.indeterminate = !nowAllSelected && nowSomeSelected;
    }
}
let savedFeatures = [];
function toggleCategories() {
    const generalFiltersContainer = document.getElementById('js-general-featured');
    const allCategories = document.getElementById('js-specific-featured');
    const viewAllButton = document.getElementById('js-button-featured');
    const featureData = data_select['feature'];
    if (generalFiltersContainer && allCategories && viewAllButton) {
        const isHidden = allCategories.classList.contains('d-none');
        if (isHidden) {
            allCategories.classList.remove("d-none");
            generalFiltersContainer.classList.add("d-none");
            viewAllButton.textContent = 'Ocultar características';
            savedFeatures = [...featureData];
            for (let i = 0; i < featureData.length; i++) {
                const value = featureData[i];
                if (value.includes(',')) {
                    featureData.splice(i, 1);
                    i--;
                }
            }
        }
        else {
            allCategories.classList.add("d-none");
            generalFiltersContainer.classList.remove("d-none");
            viewAllButton.textContent = 'Ver todas las características';
        }
    }
}
function showFilters(value, action) {
    const element = document.querySelector(`${value}`);
    if (action == 'show') {
        element.style.display = 'flex';
    }
    else {
        element.style.display = 'none';
    }
}
